module.exports = __webpack_public_path__ + "static/media/BGP-CHLSeries.de99634d.pdf";